import { Input } from 'antd'
import React, { useState } from 'react'
import classNames from 'classnames';
import { REG } from '@/utils/consts';
import styles from  './index.less';

//强弱密码
export default function StrongOrWeakPwdInput(props) {

  const { onChange, ...options } = props;
  const [isStrong,setIsStrong] = useState(null);
  //正则  数字和字母组合大于6

  const validator = (e)=>{
    if(REG.test(e.target.value)){
      setIsStrong(true)
    }else{  
      setIsStrong(false)
    }
    onChange(e)
  }

  return (
    <div className={styles.strongOrWeakPwdInput}>
      <Input  onChange={validator} {...options}/>
      <div className='status-wrapper'>
        <div className={classNames('weak', { isWeak: !isStrong, isStrong: isStrong })}></div>
        <div className={classNames('strong', { isStrong: isStrong })}></div>
        <span className='status-text'>密码强度：{isStrong?'强':'弱'}</span>
      </div>
    </div>
  )
}
